// @ts-check
import moment from 'moment-timezone'
import { empty } from '@bluecrew/bluecrew-lib'
import { pipe, pluck, keys, prop } from 'ramda'
import jobOverlapModal from "../../manage-jobs/job-overlap-modal/job-overlap-modal.html";
import { JobOverlapModalController } from "../../manage-jobs/job-overlap-modal/job-overlap-modal.ctrl";

// const getSelected = filter(propEq('selected', true))
// const mask = (a, b) => a | b
// const reduceDayMask = pipe(
//   getSelected,
//   pluck('value'),
//   reduce(mask, 0)
// )
const workerStatuses = {
  'SUSPENDED': {class: 'warning', description: 'Suspended'},
  'ELIGIBLE': {class: 'success', description: 'Eligible'},
  'FIRED': {class: 'danger', description: 'Fired'},
  'FAILED_INTERVIEW': {class: 'danger', description: 'Failed Interview'},
  'FOLLOW_UP_INTERVIEW': {class: 'primary', description: 'Needs Interview'},
  'PASSED_INTERVIEW': {class: 'primary', description: 'Passed Interview'},
  'STARTED_SIGN_UP': {class: 'default', description: 'Signed Up'},
  'PENDING': {class: 'rose', description: 'Pending'},
  'ENTERED_GENERAL_INFO': {class: 'rose', description: 'Entered General Info'},
  'SIGNED_CONTRACT': {class: 'rose', description: 'Sign Contract'},
  'ENTERED_BACKGROUND_CHECK_INFO': {class: 'rose', description: 'Entered Background Check'},
  'RUNNING_BACKGROUND_CHECK': {class: 'passive', description: 'Running Checkr'},
  'ELIGIBLE_EOR': {class: 'passive', description: 'EOR'},
  'ENTERED_TAX_INFO': {class: 'passive', description: 'Entered Tax Info'},
  'NO_SHOW_INTERVIEW': {class: 'dark', description: 'No Show Interview'},
  'DOUBLE_PROFILE': {class: 'dark', description: 'Duplicate Account'},
  'PAUSED_PROFILE': {class: 'dark', description: 'Paused'},
  'NEEDS_I9': {class: 'primary', description: 'Needs I9'},
  'FAILED_BACKGROUND_CHECK': {class: 'danger', description: 'Failed Background'},
  'NEEDS_CREWMEMBER_I9': {class: 'primary', description: 'Agent Selection'},
  'NEEDS_I9_AGENT': {class: 'primary', description: 'Needs I9 Agent'},
  'INACTIVE': {class: 'dark', description: 'Inactive'},
}

class AddWorkerController {
  /* @ngInject */
  constructor ($mdDialog, $stateParams, Users, job, shift, $mdToast) {
    this.job = job
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.minStartDate = new Date()
    this.minEndDate = new Date()
    this.workerStatuses = workerStatuses
    if (shift) {
      this.shift = shift
      this.startDate = moment(shift.start || job.start_date).format()
      let shiftStartMinute = moment(job.start_date).get('minute')
      let shiftStartHour = moment(job.start_date).get('hour')
      let startTime = moment().add(1, 'days').set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0}).format()
      this.startTime = new Date(startTime)
      this.endDate = moment().add(30, 'days').format()
      let shiftEndMinute = moment(job.end_date).get('minute')
      let shiftEndHour = moment(job.end_date).get('hour')
      let endTime = moment().set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0}).format()
      this.endTime = new Date(endTime)
    }
    this.needed = 1
    this.title = job.title
    this.timezone = job.timezone
    this.showShiftDates = false
    // this.days = reduceDayMask(job.days)
    this.Users = Users
    this.directInvite = false
    this.UserSearch = Users.userSearch()
    this.page = ''
    this.hits = []
    this.query
    this.facets = {}
    this.searchRadius = 24000
    this.facetHeaders = this.UserSearch.state.facets
    this.UserSearch.on('result', results => {
      this.hits = results.hits
      this.page = '' + (results.page + 1)
      this.totalPages = results.nbPages
      this.segmentSize = results.nbHits
      this.facetHeaders.forEach((facet) => {
        this.facets[facet] = results.getFacetValues(facet)
      })
    })
    // this.UserSearch.setQueryParameter('status', 'ELIGIBLE')
    this.UserSearch.setQuery('').search()
    if (!empty(job.usersOnJob)) {
      this.usersOnJob = job.usersOnJob
      this.userIds = keys(job.usersOnJob)
      this.needed = this.userIds.length
      this.directInvite = true
    }
  }

  validateDate () {
    this.errors = []
    let startDate = moment(this.startDate)
    let endDate = moment(this.endDate)
    if (startDate > endDate) {
      this.errors.push('End date is before start date')
      this.jobTimeForm.startDate.$error = {maxdate: true}
      this.jobTimeForm.$invalid = true
    }
  }

  toggleFacet (name, facetType) {
    this.UserSearch.toggleRefinement(facetType, name).search()
    this.UserSearch.on('result', results => {
      this.$scope.$apply(this.facets[facetType] = results.getFacetValues(facetType))
    })
  }

  addWorkerShifts (worker) {
    // If Manage Jobs Page since it passes in a different job ID
    const jobId = this.job.id || this.job.job_id
    const lateStartDate = this.job.shift !== 0 ? this.startDate : null

    this.putWorkerOnJob(worker, jobId, lateStartDate)
  }

  putWorkerOnJob (worker, jobId, lateStartDate) {
    this.Users.putOnJob([worker.external_id], jobId, lateStartDate)
    .then(() => {
      this.$mdToast.showSimple(`Added ${worker.first_name} On Job!`)
      this.$mdDialog.hide(worker)
    })
    .catch((err) => {
      if (err.status && err.status === 409) {
        this.handleOverlap(err)
      } else if (err.data && err.data.reason && typeof err.data.reason === 'string' && err.data.reason.trim()) {
        const message = err.data.reason.trim().substring(0, 200)
        this.$mdToast.show(this.$mdToast.simple(message).hideDelay(10000))
      } else {
        this.$mdToast.showSimple('Unable to Put user On job')
      }
    })
  }

  handleOverlap (e) {
    const users = e.data.reason ? pipe(prop('reason'), JSON.parse, pluck('name'))(e.data) : "User(s)"
    const text = `${users} has a conflicting schedule & cant be added to this job.`

    const confirm = {
      parent: document.getElementById('add-worker-modal-id'),
      multiple: true,
      fullscreen: true,
      template: jobOverlapModal,
      controller: JobOverlapModalController,
      ariaLabel: 'Job overlap',
      controllerAs: 'e',
      locals:{
        message: text,
      },
    }
    return this.$mdDialog.show(confirm)
  }

  usersearch () {
    if (this.queryLatLong) {
      this.UserSearch.setQueryParameter('aroundLatLng', this.queryLatLong)
    }
    this.UserSearch.setQuery(this.query).search()
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  hide () {
    let directInvites = null
    let shiftStartMinute = moment(this.startTime).get('minute')
    let shiftStartHour = moment(this.startTime).get('hour')
    let newStartDate = moment(this.startDate).set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0}).format()
    let shiftEndMinute = moment(this.endTime).get('minute')
    let shiftEndHour = moment(this.endTime).get('hour')
    let newEndDate = moment(this.endDate).set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0}).format()
    if (this.directInvite) {
      directInvites = this.userIds
    }
    this.$mdDialog.hide({startDate: newStartDate, endDate: newEndDate, needed: this.needed, timezone: this.timezone, days: this.days, userIds: directInvites})
  }

}

export default AddWorkerController
